import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./msalConfig.js";
import { msalConfigB2C } from "./msalConfigB2C.js";
import Cookies from 'js-cookie';

export const msalInstanceAzureAD = new PublicClientApplication(msalConfig); // Azure AD
await msalInstanceAzureAD.initialize(); // Ensure the instance is initialized

export const msalInstanceAzureADB2C = new PublicClientApplication(msalConfigB2C); // Azure AD B2C
await msalInstanceAzureADB2C.initialize(); // Ensure the instance is initialized

const provider = localStorage.getItem("loginProvider");

if (provider === "b2c") {
    try {
        const b2cResponse = await msalInstanceAzureADB2C.handleRedirectPromise();
        if (b2cResponse) {
            msalInstanceAzureADB2C.setActiveAccount(b2cResponse.account);
            sessionStorage.setItem("lastAccountId", b2cResponse.account.homeAccountId);
            Cookies.set("idToken", b2cResponse.accessToken || b2cResponse.idToken);
            localStorage.setItem("isauth", "true");
        }
    } catch (error) {
        console.error("B2C Redirect error:", error);
    }
} else if (provider === "entra") {
    try {
        const adResponse = await msalInstanceAzureAD.handleRedirectPromise();
        if (adResponse) {
            msalInstanceAzureAD.setActiveAccount(adResponse.account);
            Cookies.set("msGraphToken", adResponse.accessToken);
            Cookies.set("idToken", adResponse.idToken);
            localStorage.setItem("isauth", "true");
        }
    } catch (error) {
        console.error("Azure AD Redirect error:", error);
    }
}
